import {defineStore} from 'pinia'


export const useFlowStore = defineStore('flow', {
    state: () => ({
        formSubmission: 'default', // default, success, fail
        participationStatus: 'default', // default, confirmed, declined
        isFormEditionActive: false,
    }),
    actions: {
        initialize({settings, items}, bookingData) {

        },
        formSubmissionTransition(state){
            this.formSubmission = state;
        },
        participationStatusTransition(state){
            this.participationStatus = state;
        },
        activateFormEdition(){
            this.formSubmissionTransition('default');
            this.participationStatusTransition('default');
            this.isFormEditionActive = true;
        },
        deactivateFormEdition(){
            this.isFormEditionActive = false;
        }


    }

})
